import { CanAccess, useGo } from "@refinedev/core";
import { Space, Tooltip, Typography, Button } from "antd";
import { useTranslate } from "#src/hooks";
import { DownloadOutlined, EyeOutlined } from "@ant-design/icons";
import { RefObject } from "react";

export type VideoCardToolbarProps = {
  videoId: string;
  linkRef: RefObject<HTMLAnchorElement>;
};

export const VideoCardToolbar = ({
  videoId,
  linkRef,
}: VideoCardToolbarProps) => {
  const t = useTranslate();
  const go = useGo();

  const handleDownload = () => {
    return linkRef.current?.click();
  };

  const handleShowMedia = () => {
    go({
      to: {
        resource: "media_media",
        action: "show",
        id: videoId,
      },
    });
  };

  return (
    <Space size={"small"}>
      <Tooltip title={t("media.batches.list.copyId")}>
        <Typography.Text
          copyable={{ text: videoId, tooltips: false }}
          style={{ marginRight: 5 }}
        />
      </Tooltip>
      <CanAccess resource="media_generation_steps" action="show">
        <Tooltip title={t("media.batches.list.showSteps")}>
          <Button
            onClick={handleShowMedia}
            icon={<EyeOutlined />}
            shape="circle"
            type="text"
          ></Button>
        </Tooltip>
      </CanAccess>
      <Tooltip title={t("media.batches.list.download")}>
        <Button
          onClick={handleDownload}
          icon={<DownloadOutlined />}
          shape="circle"
          type="text"
        ></Button>
      </Tooltip>
    </Space>
  );
};
